import React from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'

// Package data - in a real app, this would come from an API or database
const packageData = {
  'rajasthan-5n-6d': {
    id: 'rajasthan-5n-6d',
    title: 'Rajasthan Tour Package',
    subtitle: '5 Nights / 6 Days',
    image: '/assets/img/rajasthan.jpg',
    price: '₹22,999',
    duration: '6 days',
    location: 'Rajasthan',
    persons: '2 Person',
    description: 'Discover the royal palaces, majestic forts, and vibrant culture of the Land of Kings',
    overview: 'Experience the royal grandeur of Rajasthan with this comprehensive 5 nights and 6 days tour package. Journey from Bhopal to explore Chittorgarh Fort, Jodhpur, Jaisalmer with desert camp experience, Longewala War Memorial, and Tanot Mata Mandir. Immerse yourself in the rich heritage, magnificent architecture, and colorful traditions of this princely state.',
    itinerary: [
      {
        day: 1,
        title: 'Departure to Chittorgarh',
        activities: [
          'Departure from Bhopal to Sanwariya Seth, Bhilwara (490 Kms / 12 Hrs Journey Approx.)',
          'Arrival & Darshanam at Sanwariya Seth',
          'After Darshanam proceed to Chittorgarh (60 Kms / 1.5 Hrs Journey Approx.)',
          'Arrival Chittorgarh, Check-in at Hotel',
          'Night stay at Chittorgarh'
        ]
      },
      {
        day: 2,
        title: 'Departure to Jodhpur',
        activities: [
          'Morning after breakfast, check-out from hotel',
          'On the way visit Chittorgarh Fort',
          'Departure to Jodhpur (320 Kms / 8-9 Hrs Journey Approx.)',
          'Arrival Jodhpur, Check-in at Hotel',
          'Night stay at Jodhpur'
        ]
      },
      {
        day: 3,
        title: 'Jodhpur to Jaisalmer',
        activities: [
          'Morning after breakfast, check-out from hotel',
          'Departure to Jaisalmer (280 Kms / 5 Hrs Journey Approx.)',
          'Arrival Jaisalmer, Check-in at Camp & Relax',
          'In the evening enjoy Rajasthani Cultural Dance Show',
          'Overnight stay at Camp'
        ]
      },
      {
        day: 4,
        title: 'Day Excursion - Longewala Post, War Memorial & Tanot Mata Mandir',
        activities: [
          'Morning after breakfast, proceed to visit Longewala Post',
          'Longewala Post is famous for the war fought between India & Pakistan in the year 1971',
          'Visit Longewala War Memorial - dedicated to the soldiers who fought in the Longewala Battle of the 1971 India-Pakistan War',
          'Later in the evening visit Tanot Mata Mandir',
          'Enjoy Jeep Safari and Camel Safari',
          'After visit return to Camp',
          'Night stay at Camp'
        ]
      },
      {
        day: 5,
        title: 'Departure to Kota / Chittorgarh',
        activities: [
          'Morning after breakfast, check-out from Camp',
          'Departure to Kota (650 Kms / 12 Hrs Journey Approx.) OR Departure to Chittorgarh (580 Kms / 10 Hrs Journey Approx.)',
          'Arrival Kota / Chittorgarh, Check-in at Hotel',
          'Night stay at Kota / Chittorgarh'
        ]
      },
      {
        day: 6,
        title: 'Journey Day - Return to Bhopal',
        activities: [
          'Morning after breakfast, check-out from hotel',
          'Departure to Bhopal from Kota (350 Kms / 7 Hrs Journey Approx.) OR Departure to Bhopal from Chittorgarh (470 Kms / 9 Hrs Journey Approx.)',
          'Tour concludes with wonderful memories'
        ]
      }
    ],
    inclusions: [
      '1 or 2 Night Accommodation in Chittorgarh Hotel with Breakfast on Double Sharing Basis',
      '1 Night Accommodation in Jodhpur Hotel with Breakfast on Double Sharing Basis',
      '2 Night Accommodation in Jaisalmer Camp with Breakfast & Dinner on Double Sharing Basis',
      '1 Night Accommodation in Kota Hotel with Breakfast on Double Sharing',
      'Sight Seeing as per Itinerary',
      'All Tolls, Tax, Fuel, Parking, Driver Allowances'
    ],
    exclusions: [
      'Shopping & Tips',
      'Any Additional Services like: Food & Beverages, Medical Facilities etc.',
      'Travel Insurance & Rescue Cost',
      'Expenses incurred due to any factors beyond our control like Natural Calamities, Heavy Snow Fall, Landslides, Political Insurgencies, Strike etc.'
    ],
    hotels: [
      {
        city: 'Chittorgarh',
        name: 'Hotel (1 or 2 Nights)',
        category: 'Standard',
        nights: '1-2',
        meals: 'Breakfast'
      },
      {
        city: 'Jodhpur',
        name: 'Hotel (1 Night)',
        category: 'Standard',
        nights: 1,
        meals: 'Breakfast'
      },
      {
        city: 'Jaisalmer',
        name: 'Desert Camp (2 Nights)',
        category: 'Camp',
        nights: 2,
        meals: 'Breakfast & Dinner'
      },
      {
        city: 'Kota / Chittorgarh',
        name: 'Hotel (1 Night)',
        category: 'Standard',
        nights: 1,
        meals: 'Breakfast'
      }
    ],
    transportation: 'Private AC Vehicle with Driver',
    terms: [
      'For package confirmation, you need to deposit only 50% payment in our company account and receive your booking voucher',
      'Guest will have to make 100% payment before 30 days of arrival. Otherwise booking will be considered as cancelled',
      'Package can be altered/changed as per the customer\'s requirement/interest if possible (Subject to Availability)',
      'Check-out time of the hotel mentioned is 10:00 Hrs. Check-in time is 12:00 Noon. (Early Check-in is subject to availability)',
      'We may reschedule the sightseeing days subject to weather conditions & to ensure smooth execution of tours',
      'We shall not be responsible for any cancellation of cabs or buses due to bad weather',
      'All cancellations are to be communicated in writing and advance amount is non-refundable',
      '30 Days Prior to Departure: Advance amount is non-refundable',
      '30 Days to 15 Days Prior to Departure: 50% of Total Tour Cost',
      '14 Days to 07 Days Prior to Departure: 75% of Total Tour Cost',
      '07 Days to 01 Days Prior to Departure: 100% of Total Tour Cost'
    ],
    validFrom: 'February 2026',
    validTill: 'February 2026'
  },
  'goa-4d': {
    id: 'goa-4d',
    title: 'Goa Tour Package',
    subtitle: '4 Days',
    image: '/assets/img/goa.jpg',
    price: '₹15,999',
    duration: '4 days',
    location: 'Goa',
    persons: '2 Person',
    description: 'Experience the pristine beaches, vibrant nightlife, and Portuguese heritage of India\'s party capital',
    overview: 'Enjoy a perfect beach vacation in Goa with this 4-day package. Relax on pristine beaches, explore Portuguese heritage, and experience the vibrant nightlife.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Goa',
        activities: [
          'Arrive at Goa Airport/Railway Station',
          'Transfer to hotel and check-in',
          'Evening visit to Calangute Beach',
          'Overnight stay in Goa'
        ]
      },
      {
        day: 2,
        title: 'North Goa Tour',
        activities: [
          'Breakfast at hotel',
          'Visit Baga Beach and Anjuna Beach',
          'Explore Fort Aguada',
          'Visit Basilica of Bom Jesus',
          'Evening free for leisure',
          'Overnight stay in Goa'
        ]
      },
      {
        day: 3,
        title: 'South Goa Tour',
        activities: [
          'Breakfast at hotel',
          'Visit Colva Beach and Palolem Beach',
          'Explore Old Goa churches',
          'Shopping at local markets',
          'Overnight stay in Goa'
        ]
      },
      {
        day: 4,
        title: 'Departure',
        activities: [
          'Breakfast at hotel',
          'Check-out from hotel',
          'Transfer to Airport/Railway Station',
          'Departure'
        ]
      }
    ],
    inclusions: [
      'Accommodation in beach resort (3-star category)',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All applicable taxes'
    ],
    exclusions: [
      'Airfare/Train fare',
      'Lunch and dinner',
      'Water sports activities',
      'Personal expenses',
      'Travel insurance'
    ],
    hotels: [
      {
        city: 'Goa',
        name: 'Beach Resort or Similar',
        category: '3 Star',
        nights: 3
      }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      'Prices valid for mentioned travel period',
      'Hotel check-in: 14:00 hrs, check-out: 11:00 hrs',
      '50% advance payment required',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'kerala-5d': {
    id: 'kerala-5d',
    title: 'Kerala Tour Package',
    subtitle: '5 Days',
    image: '/assets/img/kerela.jpg',
    price: '₹18,999',
    duration: '5 days',
    location: 'Kerala',
    persons: '2 Person',
    description: 'Explore the backwaters, lush green landscapes, and rich cultural heritage of God\'s Own Country',
    overview: 'Discover the natural beauty of Kerala with houseboat stays, tea gardens, and serene backwaters.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Cochin',
        activities: [
          'Arrive at Cochin Airport',
          'Transfer to hotel and check-in',
          'Evening city tour',
          'Overnight stay in Cochin'
        ]
      },
      {
        day: 2,
        title: 'Cochin to Munnar',
        activities: [
          'Breakfast at hotel',
          'Drive to Munnar (approx. 4 hours)',
          'Check-in to hotel',
          'Visit tea gardens',
          'Overnight stay in Munnar'
        ]
      },
      {
        day: 3,
        title: 'Munnar Sightseeing',
        activities: [
          'Breakfast at hotel',
          'Visit Eravikulam National Park',
          'Explore tea plantations',
          'Visit waterfalls',
          'Overnight stay in Munnar'
        ]
      },
      {
        day: 4,
        title: 'Munnar to Alleppey',
        activities: [
          'Breakfast at hotel',
          'Drive to Alleppey',
          'Check-in to houseboat',
          'Overnight stay in houseboat'
        ]
      },
      {
        day: 5,
        title: 'Departure',
        activities: [
          'Breakfast on houseboat',
          'Check-out and transfer to Cochin Airport',
          'Departure'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels and houseboat',
      'Daily breakfast',
      'All transfers by private AC vehicle',
      'All applicable taxes'
    ],
    exclusions: [
      'Airfare/Train fare',
      'Lunch and dinner',
      'Entrance fees',
      'Personal expenses',
      'Travel insurance'
    ],
    hotels: [
      {
        city: 'Cochin',
        name: 'Hotel or Similar',
        category: '3 Star',
        nights: 1
      },
      {
        city: 'Munnar',
        name: 'Resort or Similar',
        category: '3 Star',
        nights: 2
      },
      {
        city: 'Alleppey',
        name: 'Houseboat',
        category: 'Deluxe',
        nights: 1
      }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      'Prices valid for mentioned travel period',
      'Hotel check-in: 14:00 hrs, check-out: 11:00 hrs',
      '50% advance payment required',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'assam-meghalaya-arunachal-8n-9d': {
    id: 'assam-meghalaya-arunachal-8n-9d',
    title: 'Assam - Meghalaya - Arunachal Pradesh Tour',
    subtitle: '8 Nights / 9 Days',
    image: '/assets/img/darjeeling.jpg',
    price: 'Contact Us',
    duration: '9 days',
    location: 'North East India',
    persons: '2 Person',
    description: 'Explore the pristine beauty of North East India with Assam, Meghalaya, and Arunachal Pradesh',
    overview: 'Discover the untouched beauty of North East India with this comprehensive 8 nights and 9 days tour covering Guwahati, Shillong, Cherrapunji, Tezpur, Dirang, Tawang, and Bomdila. Experience diverse cultures, stunning landscapes, and rich biodiversity.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival Guwahati & Transfer to Shillong',
        activities: [
          'Arrival at Guwahati Airport, pick-up and transfer to Shillong (90 Kms / 3-4 Hrs)',
          'On the way visit Umiam Lake & Barapani',
          'Arrival Shillong, check-in at hotel & relax',
          'Visit local Shillong market (at your own)',
          'Dinner & night stay in Shillong'
        ]
      },
      {
        day: 2,
        title: 'Cherrapunji Excursion / Mawlynnong',
        activities: [
          'Day trip to Cherrapunji (Sohra) - one of the wettest places on Earth',
          'Visit Elephant Falls, Nohkalikai Falls, Mawsmai Cave',
          'Explore Seven Sisters Falls and Eco Park',
          'OR visit Mawlynnong (Asia\'s Cleanest Village)',
          'Visit Living Root Bridge, Dawki River',
          'Return to Shillong, dinner & night stay'
        ]
      },
      {
        day: 3,
        title: 'Shillong to Tezpur',
        activities: [
          'After breakfast, check-out and departure to Tezpur (245 Kms / 6-7 Hrs)',
          'Cross Bramhaputra Bridge on the way',
          'Arrival Tezpur, check-in at hotel',
          'Dinner & night stay in Tezpur'
        ]
      },
      {
        day: 4,
        title: 'Tezpur to Dirang',
        activities: [
          'After breakfast, proceed to Dirang (200 Kms)',
          'Visit Tipi Orchidarium with 500+ orchids',
          'Visit Nag Temple, waterfalls, Apple Orchid',
          'Visit Dirang Monastery & Kala Chakra Monastery',
          'Check-in at hotel, dinner & night stay'
        ]
      },
      {
        day: 5,
        title: 'Dirang to Tawang',
        activities: [
          'After breakfast, check-out and departure to Tawang (150 Kms)',
          'Visit Sela Pass (13,700 Feet) and Sela Lake',
          'Visit Jang Waterfall and Jaswantgarh War Memorial',
          'Visit Nuranng Waterfalls',
          'Visit Tawang Monastery & local market',
          'Check-in at hotel, dinner & night stay'
        ]
      },
      {
        day: 6,
        title: 'Tawang - Bum La Pass - Tawang',
        activities: [
          'After breakfast, proceed to Bum La Pass',
          'Visit Madhuri Lake and Sangester Lake',
          'Drive to Bum La Pass (15,200 Feet)',
          'Visit P TSO Lake during return',
          'Evening free at leisure, dinner & overnight stay'
        ]
      },
      {
        day: 7,
        title: 'Tawang to Bomdila',
        activities: [
          'After breakfast, check-out and departure to Bomdila (190 Kms)',
          'Visit Upper Gonpa & Lower Gonpa & Tenga Valley',
          'Enjoy beautiful scenic views of Himalayas',
          'Visit local markets in the evening',
          'Dinner & overnight stay at hotel in Bomdila'
        ]
      },
      {
        day: 8,
        title: 'Bomdila to Guwahati',
        activities: [
          'Check-out from hotel and departure to Guwahati (270 Kms / 6-8 Hrs)',
          'On the way visit Nichi Phula Waterfalls, Elephant Flat & Dolphin View Point',
          'Arrival Guwahati, check-in at hotel',
          'Dinner & night stay in Guwahati'
        ]
      },
      {
        day: 9,
        title: 'Departure',
        activities: [
          'After breakfast, check-out from hotel',
          'Transfer to Guwahati Airport',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels as per itinerary',
      'Meals as specified (Breakfast/Dinner)',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Shopping & Tips',
      'Any additional services like Food & Beverages, Medical Facilities etc.',
      'Travel Insurance & Rescue Cost',
      'Expenses due to natural calamities, political insurgencies, strike etc.'
    ],
    hotels: [
      { city: 'Shillong', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Tezpur', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Dirang', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Tawang', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Bomdila', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Guwahati', name: 'Hotel', category: 'Standard', nights: 1 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required for booking confirmation',
      '100% payment before 30 days of arrival',
      'Package can be altered/changed as per customer requirement (Subject to Availability)',
      'Check-out time: 10:00 Hrs, Check-in time: 12:00 Noon',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'kashmir-5n-6d': {
    id: 'kashmir-5n-6d',
    title: 'Kashmir Tour Package',
    subtitle: '5 Nights / 6 Days',
    image: '/assets/img/himachal.jpg',
    price: 'Contact Us',
    duration: '6 days',
    location: 'Kashmir',
    persons: '2 Person',
    description: 'Experience the paradise on earth with houseboats, gardens, and snow-capped mountains',
    overview: 'Discover the breathtaking beauty of Kashmir with this 5 nights and 6 days tour. Visit Srinagar with houseboat stay, Gulmarg with Gondola ride, and Pahalgam with Aru Valley, Chandanwari, and Betaab Valley.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival Srinagar',
        activities: [
          'Arrival at Srinagar Airport',
          'Pick-up and transfer to Houseboat',
          'Delicious dinner & overnight stay at Houseboat in Srinagar'
        ]
      },
      {
        day: 2,
        title: 'Day Excursion - Visit Local Srinagar',
        activities: [
          'After breakfast, visit Adi Shankracharya (Heritage Site)',
          'Take a Shikara Ride at Dal Lake',
          'After lunch, visit Hazratbal Shrine',
          'Return to hotel, dinner & night stay'
        ]
      },
      {
        day: 3,
        title: 'Srinagar to Gulmarg',
        activities: [
          'After breakfast, check-out and transfer to Gulmarg (55 Kms / 2 Hrs)',
          'Check-in at hotel',
          'Take the world-famous Gondola Cable Car Ride to Apharwat Peak',
          'Explore Gulmarg Meadows and Golf Course',
          'Evening relax or explore local shops',
          'Dinner & night stay in Gulmarg'
        ]
      },
      {
        day: 4,
        title: 'Gulmarg to Pahalgam',
        activities: [
          'After breakfast, check-out and transfer to Pahalgam (155 Kms / 4 Hrs)',
          'On the way visit Pampore (Saffron Capital) and Anantnag',
          'Arrival Pahalgam, check-in at hotel',
          'Evening by the river or explore local market',
          'Dinner & night stay in Pahalgam'
        ]
      },
      {
        day: 5,
        title: 'Day Excursion - Explore Pahalgam',
        activities: [
          'After breakfast, visit Aru Valley',
          'Visit Chandanwari (starting point for Amarnath Yatra)',
          'Visit Betaab Valley (famous for Bollywood film shoots)',
          'Evening shop for local handicrafts',
          'Dinner & night stay in Pahalgam'
        ]
      },
      {
        day: 6,
        title: 'Departure',
        activities: [
          'After breakfast, check-out from hotel',
          'Departure to Srinagar (90 Kms / 2.5 Hrs)',
          'Drop at Srinagar Airport',
          'Departure with blissful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels and houseboat',
      'Daily breakfast and dinner',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Shopping & Tips',
      'Any additional services',
      'Travel Insurance',
      'Gondola ride charges (if not included)'
    ],
    hotels: [
      { city: 'Srinagar', name: 'Houseboat', category: 'Deluxe', nights: 2 },
      { city: 'Gulmarg', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Pahalgam', name: 'Hotel', category: 'Standard', nights: 2 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'ladakh-7n-8d': {
    id: 'ladakh-7n-8d',
    title: 'Ladakh Tour Package',
    subtitle: '7 Nights / 8 Days',
    image: '/assets/img/himachal-pack.jpg',
    price: 'Contact Us',
    duration: '8 days',
    location: 'Ladakh',
    persons: '2 Person',
    description: 'Explore the land of high passes, pristine lakes, and Buddhist monasteries',
    overview: 'Experience the mystical land of Ladakh with this 7 nights and 8 days tour. Visit Leh, Nubra Valley via Khardungla Pass, Pangong Lake, and Kargil. Discover ancient monasteries, high-altitude lakes, and breathtaking landscapes.',
    itinerary: [
      {
        day: 1,
        title: 'Departure to Delhi',
        activities: [
          'Departure from Saugor Railway Station to Delhi at 6:00 PM',
          'Overnight journey by train'
        ]
      },
      {
        day: 2,
        title: 'Arrival Delhi & Flight to Leh',
        activities: [
          'Arrival Delhi at 4:25 AM',
          'Catch flight to Leh at 6:50 AM',
          'Arrival Leh Airport at 8:10 AM',
          'Pick-up and transfer to hotel',
          'Check-in and rest for the day',
          'Overnight stay in Leh'
        ]
      },
      {
        day: 3,
        title: 'Day Excursion - Visit Local Leh',
        activities: [
          'After breakfast, visit Hall of Fame (War Museum)',
          'Visit Spituk Monastery (founded in 11th Century)',
          'Visit Pathar Sahib (Gurudwara)',
          'Visit Magnetic Hill and Sangam of Indus & Zanskar River',
          'Return to hotel, night stay in Leh'
        ]
      },
      {
        day: 4,
        title: 'Departure to Nubra Valley',
        activities: [
          'After breakfast, check-out and departure to Nubra Valley (165 Kms / 5 Hrs)',
          'Via Khardungla Pass (18,380ft) - World\'s Highest Motorable Road',
          'Visit Diskit Monastery (founded in 1420 A.D.)',
          'Visit Hunder Village and Double-Humped Bactrian Camel Safari',
          'Check-in at camp, dinner & night stay'
        ]
      },
      {
        day: 5,
        title: 'Nubra Valley - Pangong - Leh',
        activities: [
          'Early breakfast, check-out from camp',
          'Drive to Pangong Lake (175 Kms / 7 Hrs) via Shayok',
          'Visit the famous Blue Brackish Saltwater Lake (5-6 Kms width, 134 Kms length)',
          'After visit, departure to Leh (230 Kms / 6 Hrs)',
          'Arrival Leh, check-in at hotel & night stay'
        ]
      },
      {
        day: 6,
        title: 'Day Excursion - Explore Leh',
        activities: [
          'After breakfast, visit Thiksey Monastery',
          'Visit Druk Pema School (3 Idiots School)',
          'Visit Leh Palace, Shey Palace & Monastery',
          'Return to hotel, night stay in Leh'
        ]
      },
      {
        day: 7,
        title: 'Leh to Kargil',
        activities: [
          'After breakfast, check-out and departure to Kargil (220 Kms / 5 Hrs)',
          'Visit Kargil War Memorial',
          'Check-in at hotel, dinner & night stay'
        ]
      },
      {
        day: 8,
        title: 'Kargil to Srinagar',
        activities: [
          'After breakfast, check-out and departure to Srinagar (210 Kms / 5 Hrs)',
          'Arrival Srinagar, drop at airport',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels and camps',
      'Meals as specified',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Train fare and flight tickets',
      'Shopping & Tips',
      'Any additional services',
      'Travel Insurance',
      'Inner Line Permits (if required)'
    ],
    hotels: [
      { city: 'Leh', name: 'Hotel', category: 'Standard', nights: 4 },
      { city: 'Nubra Valley', name: 'Camp', category: 'Deluxe', nights: 1 },
      { city: 'Kargil', name: 'Hotel', category: 'Standard', nights: 1 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy',
      'Inner Line Permits to be arranged separately'
    ],
    validFrom: 'May - October',
    validTill: 'May - October'
  },
  'delhi-agra-3n-4d': {
    id: 'delhi-agra-3n-4d',
    title: 'Delhi - Agra Tour Package',
    subtitle: '3 Nights / 4 Days',
    image: '/assets/img/agra.jpg',
    price: 'Contact Us',
    duration: '4 days',
    location: 'Delhi & Agra',
    persons: '2 Person',
    description: 'Visit the iconic Taj Mahal, Agra Fort, and explore the capital city of India',
    overview: 'Experience the rich history and architectural marvels of Delhi and Agra. Visit the iconic Taj Mahal, Agra Fort, Fatehpur Sikri, and explore the capital city\'s monuments and markets.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Delhi',
        activities: [
          'Arrival at Delhi Airport/Railway Station',
          'Pick-up and transfer to hotel',
          'Check-in at hotel and relax',
          'Evening free for leisure',
          'Overnight stay in Delhi'
        ]
      },
      {
        day: 2,
        title: 'Delhi Sightseeing',
        activities: [
          'After breakfast, visit Red Fort',
          'Visit Jama Masjid',
          'Visit India Gate and Rashtrapati Bhavan',
          'Visit Qutub Minar',
          'Evening explore local markets',
          'Overnight stay in Delhi'
        ]
      },
      {
        day: 3,
        title: 'Delhi to Agra',
        activities: [
          'After breakfast, check-out and drive to Agra (200 Kms / 4 Hrs)',
          'On arrival, check-in at hotel',
          'Visit Agra Fort',
          'Visit Taj Mahal (sunset view)',
          'Overnight stay in Agra'
        ]
      },
      {
        day: 4,
        title: 'Agra to Delhi & Departure',
        activities: [
          'Early morning visit Taj Mahal (sunrise view)',
          'After breakfast, visit Fatehpur Sikri',
          'Return to Delhi',
          'Drop at Airport/Railway Station',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Entrance fees to monuments',
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance'
    ],
    hotels: [
      { city: 'Delhi', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Agra', name: 'Hotel', category: 'Standard', nights: 1 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'manali-kasol-4n-5d': {
    id: 'manali-kasol-4n-5d',
    title: 'Manali - Kasol Tour Package',
    subtitle: '4 Nights / 5 Days',
    image: '/assets/img/manali.jpg',
    price: 'Contact Us',
    duration: '5 days',
    location: 'Himachal Pradesh',
    persons: '2 Person',
    description: 'Experience the beauty of mountains, valleys, and adventure activities',
    overview: 'Discover the scenic beauty of Manali and Kasol with this 4 nights and 5 days tour. Enjoy mountain views, adventure activities, and the peaceful ambiance of the Parvati Valley.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Manali',
        activities: [
          'Arrival at Manali',
          'Pick-up and transfer to hotel',
          'Check-in at hotel and relax',
          'Evening free for leisure',
          'Overnight stay in Manali'
        ]
      },
      {
        day: 2,
        title: 'Manali Local Sightseeing',
        activities: [
          'After breakfast, visit Hadimba Temple',
          'Visit Manu Temple',
          'Visit Vashisht Hot Water Springs',
          'Visit Solang Valley',
          'Evening explore Mall Road',
          'Overnight stay in Manali'
        ]
      },
      {
        day: 3,
        title: 'Manali to Kasol',
        activities: [
          'After breakfast, check-out and drive to Kasol (80 Kms / 3 Hrs)',
          'On arrival, check-in at hotel',
          'Evening explore Kasol market',
          'Overnight stay in Kasol'
        ]
      },
      {
        day: 4,
        title: 'Kasol - Kheerganga / Tosh',
        activities: [
          'After breakfast, visit Kheerganga or Tosh Valley',
          'Enjoy nature walks and scenic views',
          'Evening return to Kasol',
          'Overnight stay in Kasol'
        ]
      },
      {
        day: 5,
        title: 'Kasol to Departure',
        activities: [
          'After breakfast, check-out from hotel',
          'Transfer to Airport/Railway Station',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Adventure activities charges',
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance'
    ],
    hotels: [
      { city: 'Manali', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Kasol', name: 'Hotel', category: 'Standard', nights: 2 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'pachmarhi-2n-3d': {
    id: 'pachmarhi-2n-3d',
    title: 'Pachmarhi Tour Package',
    subtitle: '2 Nights / 3 Days',
    image: '/assets/img/himachal.jpg',
    price: 'Contact Us',
    duration: '3 days',
    location: 'Pachmarhi, Madhya Pradesh',
    persons: '2 Person',
    description: 'Explore the only hill station of Madhya Pradesh with waterfalls and caves',
    overview: 'Discover the serene beauty of Pachmarhi, the only hill station in Madhya Pradesh. Visit beautiful waterfalls, ancient caves, and enjoy the peaceful mountain atmosphere.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Pachmarhi',
        activities: [
          'Arrival at Pachmarhi',
          'Pick-up and transfer to hotel',
          'Check-in at hotel and relax',
          'Evening visit to local market',
          'Overnight stay in Pachmarhi'
        ]
      },
      {
        day: 2,
        title: 'Pachmarhi Sightseeing',
        activities: [
          'After breakfast, visit Pandav Caves',
          'Visit Jata Shankar Cave',
          'Visit Bee Falls and Apsara Falls',
          'Visit Dhoopgarh (Sunset Point)',
          'Evening free for leisure',
          'Overnight stay in Pachmarhi'
        ]
      },
      {
        day: 3,
        title: 'Departure',
        activities: [
          'After breakfast, check-out from hotel',
          'Visit Reechgarh Cave (if time permits)',
          'Transfer to Airport/Railway Station',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotel',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Entrance fees',
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance'
    ],
    hotels: [
      { city: 'Pachmarhi', name: 'Hotel', category: 'Standard', nights: 2 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'bhutan-6n-7d': {
    id: 'bhutan-6n-7d',
    title: 'Bhutan Tour Package',
    subtitle: '6 Nights / 7 Days',
    image: '/assets/img/himachal-pack.jpg',
    price: 'Contact Us',
    duration: '7 days',
    location: 'Bhutan',
    persons: '2 Person',
    description: 'Experience the land of happiness with monasteries, fortresses, and pristine nature',
    overview: 'Discover the mystical kingdom of Bhutan with this 6 nights and 7 days tour. Visit Thimphu, Punakha, Paro, and experience the unique culture, ancient monasteries, and breathtaking landscapes.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Paro & Transfer to Thimphu',
        activities: [
          'Arrival at Paro Airport',
          'Pick-up and transfer to Thimphu',
          'Check-in at hotel and relax',
          'Evening explore Thimphu',
          'Overnight stay in Thimphu'
        ]
      },
      {
        day: 2,
        title: 'Thimphu Sightseeing',
        activities: [
          'After breakfast, visit Tashichho Dzong',
          'Visit Buddha Dordenma Statue',
          'Visit National Memorial Chorten',
          'Visit Folk Heritage Museum',
          'Evening free for leisure',
          'Overnight stay in Thimphu'
        ]
      },
      {
        day: 3,
        title: 'Thimphu to Punakha',
        activities: [
          'After breakfast, drive to Punakha via Dochula Pass',
          'Visit Punakha Dzong',
          'Visit Chimi Lhakhang (Temple of Fertility)',
          'Check-in at hotel',
          'Overnight stay in Punakha'
        ]
      },
      {
        day: 4,
        title: 'Punakha to Paro',
        activities: [
          'After breakfast, drive to Paro',
          'On arrival, check-in at hotel',
          'Visit Paro Dzong and National Museum',
          'Evening explore Paro town',
          'Overnight stay in Paro'
        ]
      },
      {
        day: 5,
        title: 'Paro - Taktsang Monastery',
        activities: [
          'After breakfast, hike to Taktsang Monastery (Tiger\'s Nest)',
          'One of the most sacred sites in Bhutan',
          'Afternoon return to Paro',
          'Evening free for leisure',
          'Overnight stay in Paro'
        ]
      },
      {
        day: 6,
        title: 'Paro Local Sightseeing',
        activities: [
          'After breakfast, visit Kyichu Lhakhang',
          'Visit Drukgyel Dzong',
          'Visit traditional farmhouse',
          'Evening free for shopping',
          'Overnight stay in Paro'
        ]
      },
      {
        day: 7,
        title: 'Departure',
        activities: [
          'After breakfast, check-out from hotel',
          'Transfer to Paro Airport',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'Bhutan visa fees (if included)',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'International flight tickets',
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance',
      'Monument entrance fees'
    ],
    hotels: [
      { city: 'Thimphu', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Punakha', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Paro', name: 'Hotel', category: 'Standard', nights: 3 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Bhutan visa to be arranged separately',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'north-east-6n-7d': {
    id: 'north-east-6n-7d',
    title: 'North East Tour Package',
    subtitle: '6 Nights / 7 Days',
    image: '/assets/img/darjeeling.jpg',
    price: 'Contact Us',
    duration: '7 days',
    location: 'North East India',
    persons: '2 Person',
    description: 'Explore the diverse cultures and pristine landscapes of North East India',
    overview: 'Discover the beauty of North East India with this 6 nights and 7 days tour covering the best destinations in the region. Experience diverse cultures, stunning landscapes, and rich biodiversity.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival',
        activities: [
          'Arrival at destination',
          'Pick-up and transfer to hotel',
          'Check-in at hotel and relax',
          'Evening free for leisure',
          'Overnight stay'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance',
      'Any additional services'
    ],
    hotels: [
      { city: 'Various', name: 'Hotels', category: 'Standard', nights: 6 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },
  'udaipur-jodhpur-jaisalmer': {
    id: 'udaipur-jodhpur-jaisalmer',
    title: 'Udaipur - Jodhpur - Jaisalmer Tour Package',
    subtitle: 'Customizable Duration',
    image: '/assets/img/rajasthan.jpg',
    price: 'Contact Us',
    duration: 'Customizable',
    location: 'Rajasthan',
    persons: '2 Person',
    description: 'Explore the royal cities of Rajasthan - Udaipur, Jodhpur, and Jaisalmer',
    overview: 'Experience the royal grandeur of Rajasthan with this tour covering Udaipur (City of Lakes), Jodhpur (Blue City), and Jaisalmer (Golden City). Visit palaces, forts, and experience desert camping.',
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Udaipur',
        activities: [
          'Arrival at Udaipur',
          'Pick-up and transfer to hotel',
          'Check-in at hotel and relax',
          'Evening boat ride on Lake Pichola',
          'Overnight stay in Udaipur'
        ]
      },
      {
        day: 2,
        title: 'Udaipur Sightseeing',
        activities: [
          'After breakfast, visit City Palace',
          'Visit Jagdish Temple',
          'Visit Saheliyon ki Bari',
          'Evening free for leisure',
          'Overnight stay in Udaipur'
        ]
      },
      {
        day: 3,
        title: 'Udaipur to Jodhpur',
        activities: [
          'After breakfast, check-out and drive to Jodhpur',
          'On arrival, check-in at hotel',
          'Visit Mehrangarh Fort',
          'Visit Jaswant Thada',
          'Overnight stay in Jodhpur'
        ]
      },
      {
        day: 4,
        title: 'Jodhpur to Jaisalmer',
        activities: [
          'After breakfast, check-out and drive to Jaisalmer',
          'On arrival, check-in at desert camp',
          'Evening enjoy Rajasthani Cultural Dance Show',
          'Overnight stay at camp'
        ]
      },
      {
        day: 5,
        title: 'Jaisalmer Sightseeing',
        activities: [
          'After breakfast, visit Jaisalmer Fort',
          'Visit Patwon ki Haveli',
          'Visit Gadisar Lake',
          'Evening enjoy Camel Safari',
          'Overnight stay at camp'
        ]
      },
      {
        day: 6,
        title: 'Departure',
        activities: [
          'After breakfast, check-out from camp',
          'Transfer to Airport/Railway Station',
          'Departure with wonderful memories'
        ]
      }
    ],
    inclusions: [
      'Accommodation in hotels and desert camp',
      'Daily breakfast',
      'All transfers and sightseeing by private AC vehicle',
      'All tolls, tax, fuel, parking, driver allowances'
    ],
    exclusions: [
      'Shopping & Tips',
      'Lunch and dinner',
      'Travel Insurance',
      'Any additional services'
    ],
    hotels: [
      { city: 'Udaipur', name: 'Hotel', category: 'Standard', nights: 2 },
      { city: 'Jodhpur', name: 'Hotel', category: 'Standard', nights: 1 },
      { city: 'Jaisalmer', name: 'Desert Camp', category: 'Deluxe', nights: 2 }
    ],
    transportation: 'Private AC Vehicle',
    terms: [
      '50% advance payment required',
      '100% payment before 30 days of arrival',
      'Package can be altered as per requirement',
      'Cancellation charges apply as per policy'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  /* ==================== INTERNATIONAL PACKAGES ==================== */

  'vietnam-grand-tour-11n-12d': {
    id: 'vietnam-grand-tour-11n-12d',
    title: 'Vietnam Grand Tour',
    subtitle: '11 Nights / 12 Days',
    image: '/assets/img/vietnam.jpg',
    price: '₹1,19,000',
    duration: '12 days',
    location: 'Vietnam',
    persons: 'Per Person',
    description: 'Experience Vietnam from north to south - Hanoi, Halong Bay, Da Nang, Ho Chi Minh & Phu Quoc',
    overview: 'Experience Vietnam like never before with this comprehensive journey covering the country from north to south. Begin in Hanoi, where cultural heritage meets natural beauty, with excursions to Ninh Binh and the breathtaking Halong Bay cruise. Continue to Central Vietnam in Da Nang, home to the iconic Golden Bridge, Ba Na Hills, and the lantern-lit charm of Hoi An. Then head south to Ho Chi Minh City for a dynamic blend of history and local life, including the famous Cu Chi Tunnels and Mekong Delta. End your journey in the tropical paradise of Phu Quoc, where island hopping, theme parks, and vibrant evening experiences create the perfect finale. This itinerary is designed for travellers who want to experience Vietnam in its entirety — seamlessly and comfortably.',
    highlights: [
      'Hanoi city tour with cultural landmarks',
      'Ninh Binh scenic day trip',
      'Halong Bay deluxe cruise experience',
      'Ba Na Hills with Golden Bridge',
      'Hoi An Ancient Town with lantern boat ride',
      'Da Nang city tour & shopping',
      'Ho Chi Minh city exploration',
      'Cu Chi Tunnels & Mekong Delta experience',
      'VinWonders Phu Quoc theme park',
      '4 Island-hopping tour with speedboat',
      'Grand World with Water Taxi & Teddy Bear Museum',
      'All meals included (as per itinerary)',
      'End-to-end Vietnam coverage'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival at Hanoi - Transfer to Hotel - Half Day Hanoi City Tour',
        activities: [
          'Arrive in Hanoi and begin your journey with a guided city tour, exploring key landmarks and experiencing the cultural essence of Vietnam\'s capital',
          'Enjoy lunch before proceeding to your hotel for check-in',
          'In the evening, unwind with dinner',
          'Overnight stay at Chalcedony Grand Hotel',
          'Meals: Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Ninh Binh Day Excursion',
        activities: [
          'After breakfast, head out for a scenic day trip to Ninh Binh, known for its limestone landscapes and peaceful countryside',
          'Enjoy a relaxing exploration with included lunch before returning to Hanoi for dinner',
          'Overnight stay at Chalcedony Grand Hotel',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 3,
        title: 'Halong Bay Deluxe Cruise Experience',
        activities: [
          'Today, embark on a full-day excursion to Halong Bay',
          'Cruise through stunning limestone karsts aboard a deluxe cruise, enjoy activities onboard, and savour a delicious lunch while soaking in the breathtaking views',
          'Return to Hanoi for dinner',
          'Overnight stay at Chalcedony Grand Hotel',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 4,
        title: 'Fly to Da Nang & Coconut Forest and Hoi An Town with Lantern Release',
        activities: [
          'After breakfast, check out and proceed for your onward journey to Da Nang',
          'Upon arrival, transfer to your hotel and check in',
          'Later, head out for a cultural journey to Hoi An - begin with a basket boat ride through the coconut forest, followed by lunch',
          'In the evening, explore the lantern-lit streets of Hoi An and enjoy a peaceful lantern boat ride experience before dinner',
          'Overnight stay at Cicilia Hotels & Spa Danang',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 5,
        title: 'Ba Na Hills Tour',
        activities: [
          'Leave the bustle of Da Nang for a day and escape to the mountainous serenity of the Ba Na Hills',
          'Visit the Linh Ung Pagoda and marvel at the 220-foot (67m) statue of a Bodhisattva',
          'Take a cable car to the top of Nui Chua Mountain and grab lunch in a local restaurant',
          'Spend the rest of your afternoon captivated by the attractions at Fantasy Park',
          'Overnight stay at Cicilia Hotels & Spa Danang',
          'Meals: Breakfast included'
        ]
      },
      {
        day: 6,
        title: 'Full Day Da Nang City Tour & Shopping Experience',
        activities: [
          'After breakfast, set out for a full-day exploration of Da Nang, a vibrant coastal city known for its blend of modern attractions and cultural landmarks',
          'Visit key highlights such as the Marble Mountains, offering scenic views and spiritual significance',
          'Continue your day with visits to local markets and shopping areas for souvenirs, handicrafts, and local specialties',
          'Enjoy lunch during the tour and take in the relaxed coastal vibe of the city',
          'Overnight stay at Cicilia Hotels & Spa Danang',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 7,
        title: 'Arrival in Ho Chi Minh City & City Tour',
        activities: [
          'After breakfast, check out and fly to Ho Chi Minh City',
          'Upon arrival, enjoy lunch and proceed for hotel check-in',
          'Later, explore the city with a guided tour, discovering its vibrant streets and historical landmarks',
          'End the day with dinner',
          'Overnight stay at Ramana Saigon Hotel',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 8,
        title: 'Cu Chi Tunnels & Mekong Delta Experience',
        activities: [
          'After breakfast, head out for a full-day excursion exploring the Cu Chi Tunnels, followed by a visit to the Mekong Delta',
          'Experience local life, scenic waterways, and cultural insights with lunch included before returning for dinner',
          'Overnight stay at Ramana Saigon Hotel',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 9,
        title: 'Fly to Phu Quoc & Grand World Evening Experience',
        activities: [
          'After breakfast, transfer to the airport for your flight to Phu Quoc',
          'Later, head out in the evening to Grand World',
          'Enjoy a scenic Water Taxi ride through beautifully designed canals and explore the Teddy Bear Museum with its unique themed displays',
          'Return for dinner after a lively evening experience',
          'Overnight stay at Vinholidays Fiesta Phu Quoc',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 10,
        title: 'Phu Quoc 4 Islands Day Tour by Speedboat',
        activities: [
          'After breakfast, embark on an exciting 4-island tour by shared speedboat',
          'Explore beautiful beaches, enjoy water activities, and relax amidst stunning island scenery',
          'Lunch is included during the excursion, followed by dinner',
          'Overnight stay at Vinholidays Fiesta Phu Quoc',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 11,
        title: 'VinWonders Phu Quoc',
        activities: [
          'After breakfast, visit VinWonders for a fun-filled experience at Vietnam\'s largest theme park',
          'Enjoy lunch before returning to your hotel and relaxing, followed by dinner',
          'Overnight stay at Vinholidays Fiesta Phu Quoc',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 12,
        title: 'Departure from Phu Quoc',
        activities: [
          'After breakfast, check out from the hotel and transfer to the airport for your onward journey',
          'Concluding your unforgettable Vietnam experience',
          'Meals: Breakfast included'
        ]
      }
    ],
    inclusions: [
      '11 nights accommodation in handpicked hotels',
      'All meals included as per itinerary (Breakfast, Lunch & Dinner)',
      'Hanoi city tour with cultural landmarks',
      'Ninh Binh scenic day excursion',
      'Halong Bay deluxe cruise experience',
      'Ba Na Hills tour with Golden Bridge & cable car',
      'Hoi An Ancient Town with lantern boat ride & basket boat ride',
      'Da Nang city tour & shopping experience',
      'Cu Chi Tunnels & Mekong Delta excursion',
      'Grand World with Water Taxi & Teddy Bear Museum',
      'Phu Quoc 4 Island-hopping tour by speedboat',
      'VinWonders Phu Quoc theme park entry',
      'All internal flights & transfers as per itinerary'
    ],
    exclusions: [
      'International flight tickets',
      'Vietnam visa charges',
      'Travel insurance',
      'Personal expenses, shopping & tips',
      'Any meals or services not mentioned in inclusions',
      'Expenses due to factors beyond our control (natural calamities, flight delays, etc.)'
    ],
    hotels: [
      { city: 'Hanoi', name: 'Chalcedony Grand Hotel', category: 'Deluxe', nights: 3, meals: 'Breakfast, Lunch & Dinner' },
      { city: 'Da Nang', name: 'Cicilia Hotels & Spa Danang', category: 'Deluxe', nights: 3, meals: 'Breakfast & Dinner' },
      { city: 'Ho Chi Minh City', name: 'Ramana Saigon Hotel', category: 'Deluxe', nights: 2, meals: 'Breakfast, Lunch & Dinner' },
      { city: 'Phu Quoc', name: 'Vinholidays Fiesta Phu Quoc', category: 'Deluxe', nights: 3, meals: 'Breakfast, Lunch & Dinner' }
    ],
    transportation: 'Private & shared transfers, internal flights, deluxe cruise and speedboat as per itinerary',
    terms: [
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport with minimum 6 months validity required',
      'Vietnam visa to be arranged separately (assistance available)',
      'Package can be altered/changed as per requirement (subject to availability)',
      'Itinerary may be rescheduled subject to weather conditions and flight timings',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Cancellation charges apply as per company policy',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  'malaysia-3n-4d': {
    id: 'malaysia-3n-4d',
    title: 'Unbeatable Malaysia - City, Highlands & Theme Park',
    subtitle: '3 Nights / 4 Days',
    image: '/assets/img/malaysia.jpg',
    price: '₹60,000',
    duration: '4 days',
    location: 'Malaysia',
    persons: 'Per Person',
    description: 'Kuala Lumpur city, Genting Highlands, Batu Caves and Sunway Lagoon in one seamless trip',
    overview: 'Discover the very best of Malaysia in this compact and action-packed getaway. Explore Kuala Lumpur\'s striking skyline from the KL Tower Observation Deck, enjoy a thrilling evening at Sunway Lagoon Night Park, escape to the cool mountain air of Genting Highlands with a 2-way cable car ride, and take in the spiritual grandeur of Batu Caves. With a scenic Putrajaya drive on arrival, the Immersify Kuala Lumpur experience, and shopping at Berjaya Times Square, this itinerary blends city, culture, nature and entertainment perfectly — all with meals and transfers included.',
    highlights: [
      'Kuala Lumpur City Tour + KL Tower Observation Deck',
      'Sunway Lagoon Night Park Experience',
      'Genting Highlands Day Tour + 2-Way Cable Car',
      'Batu Caves Photo Stop (Enroute)',
      'Putrajaya Scenic Drive (Arrival Day)',
      'Immersify Kuala Lumpur Experience',
      'Shopping at Berjaya Times Square',
      'Meals Included (Breakfast + Lunch + Dinner)',
      'SIC Coach Transfers (Private Upgrade Available)',
      'Flights not included in Joining Direct*'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Kuala Lumpur with Putrajaya Tour Enroute and Sunway Lagoon Night Park',
        activities: [
          'Arrive in Kuala Lumpur and begin your journey with a comfortable transfer',
          'Start with breakfast (subject to flight timing), allowing you to relax and refresh after your arrival',
          'Post breakfast, proceed for a scenic drive through Putrajaya, known for its beautiful bridges and modern architecture',
          'Continue towards Kuala Lumpur, enjoy lunch, and complete your hotel check-in',
          'In the evening, head out for a thrilling experience at Sunway Lagoon Night Park, before returning to the hotel after dinner',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Visit to Genting Highlands with Enroute Batu Caves',
        activities: [
          'After breakfast depart for Genting Highlands',
          'Enroute make a short photo stop at Batu Caves - a limestone hill with a series of caves and cave temples, the shrine of Lord Murugan',
          'Continue drive to Genting Skyway Lower Station to board a cable car to the peak (journey takes approximately 15 minutes, subject to weather conditions)',
          'Genting Highlands, located at 2000 meters above sea level, offers a cool respite from Malaysia\'s capital city',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Breakfast included at hotel'
        ]
      },
      {
        day: 3,
        title: 'Kuala Lumpur City Tour with KL Tower Observation Deck and Immersify Experience',
        activities: [
          'Post breakfast, explore Kuala Lumpur\'s key landmarks including the Petronas Twin Towers (photo stop), National Mosque, King\'s Palace, and Independence Square',
          'The highlight of the day is the KL Tower Observation Deck, offering sweeping views of the city skyline',
          'After lunch, spend time shopping at Berjaya Times Square',
          'Conclude the day with the Immersify Kuala Lumpur experience, dinner and return to the hotel',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Breakfast included at hotel'
        ]
      },
      {
        day: 4,
        title: 'Departure from Kuala Lumpur',
        activities: [
          'After breakfast, check out from the hotel and spend your morning exploring Kuala Lumpur at your own pace',
          'Enjoy last-minute shopping at nearby markets or malls, picking up souvenirs and local finds',
          'Later, proceed to the airport for your departure',
          'A relaxed, stress-free ending to the trip',
          'Meals: Breakfast included at hotel'
        ]
      }
    ],
    inclusions: [
      'Kuala Lumpur 3 nights accommodation',
      'Daily Breakfast with Lunch & Dinners',
      'Sunway Lagoon Night Park Entry',
      'Genting Highlands Tour with 2-Way Cable Car Ride',
      'Batu Caves Visit for 60 Min',
      'Kuala Lumpur City Tour with KL Tower Observation Deck Tickets',
      'Immersify Kuala Lumpur Entry Tickets',
      'SIC Coach Transfers (Airport Included)',
      'English-Speaking Guide (15+ pax above)',
      'Driver Tips and Parking fee',
      '500ml Water Bottle'
    ],
    exclusions: [
      'International flight tickets (not included in Joining Direct)',
      'Malaysia visa charges',
      'Travel insurance',
      'Personal expenses, shopping & tips',
      'Any services not mentioned in inclusions',
      'Expenses due to factors beyond our control'
    ],
    hotels: [
      { city: 'Kuala Lumpur', name: 'Regalia Upper View Hotel', category: '4 Star', nights: 3, meals: 'Breakfast, Lunch & Dinner' }
    ],
    transportation: 'SIC Coach Transfers (Airport Included) - Private upgrade available',
    terms: [
      'Tour cost is ₹60,000 per person with 4 Star Hotels',
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport with minimum 6 months validity required',
      'Malaysia visa to be arranged separately (assistance available)',
      'Cable car operation is subject to weather conditions',
      'English-Speaking Guide provided for groups of 15+ pax',
      'Package can be altered/changed as per requirement (subject to availability)',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  'japan-classic-route-6n-7d': {
    id: 'japan-classic-route-6n-7d',
    title: 'Japan for First Timers - The Classic Route',
    subtitle: '6 Nights / 7 Days',
    image: '/assets/img/japan.jpg',
    price: '₹3,60,000',
    duration: '7 days',
    location: 'Japan',
    persons: 'Per Person',
    description: 'Tokyo 3N, Kanazawa 1N, Kyoto 2N - the Golden Route with Mount Fuji, Bullet Train & Osaka',
    overview: 'A perfectly planned 7-day Golden Route covering Tokyo, Mount Fuji, Kanazawa, Kyoto and Osaka in one smooth journey. Experience Mount Fuji in a full-day tour with Lake Kawaguchi, Chureito Pagoda, Oshino Hakkai and the 5th Station. Ride the iconic Bullet Train from Kanazawa to Kyoto — fast, scenic, and comfortable. Discover Kyoto\'s traditions with torii gates, ancient temples and hilltop city views, then feel modern Japan in Tokyo and Osaka. A smartly paced itinerary blending cities, culture, nature and everyday Japanese life — without the rush.',
    highlights: [
      'A perfectly planned 7-day Golden Route covering Tokyo, Mount Fuji, Kanazawa, Kyoto & Osaka in one smooth journey',
      'Experience Mount Fuji in a full-day tour with Lake Kawaguchi, Chureito Pagoda, Oshino Hakkai & the 5th Station',
      'Ride the iconic Bullet Train from Kanazawa to Kyoto — fast, scenic, and comfortable',
      'Discover Kyoto\'s traditions with torii gates, ancient temples & hilltop city views',
      'Feel modern Japan in Tokyo & Osaka - from Shibuya Crossing & Harajuku streets to Dotonbori nights, Kuromon markets & Osaka Castle',
      'Smartly paced itinerary blending cities, culture, nature & everyday Japanese life — without the rush'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arriving in Tokyo',
        activities: [
          'The moment you land in Tokyo, you feel it — this place is different',
          'Bright lights, quiet corners, polite smiles, and a sense of excitement in the air',
          'After settling into your hotel, you have your first evening to soak it all in',
          'Overnight stay at Asakusa View Hotel',
          'Meals: Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Feeling Tokyo: From Peaceful Shrines to Shibuya Lights',
        activities: [
          'Your day begins with the peaceful gardens of the Imperial Palace, the official residence of Japan\'s Emperor',
          'Stroll along green pathways and admire the graceful Nijubashi Bridge from a distance',
          'Head to the charming Asakusa area, walking past the lively Nakamise shopping street before reaching the beautiful Senso-ji Temple, Tokyo\'s oldest Buddhist temple',
          'Experience Shibuya Crossing and the Harajuku streets in the evening',
          'Overnight stay at Asakusa View Hotel',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 3,
        title: 'Mount Fuji & Lake Kawaguchi Experience',
        activities: [
          'Today feels like stepping into a postcard as you travel toward majestic Mount Fuji, Japan\'s most loved natural icon',
          'Your first stop is Oishi Park, with flower-lined paths opening up to stunning views of Lake Kawaguchi — part of the Fuji Five Lakes region',
          'Visit Arakurayama Sengen Park, home to the iconic Chureito Pagoda and Arakura Fuji Sengen Shrine — one of Japan\'s most photographed scenes',
          'Continue to Oshino Hakkai and the Mount Fuji 5th Station',
          'Overnight stay at Asakusa View Hotel',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 4,
        title: 'Tokyo to Kanazawa - From City Lights to Old Streets',
        activities: [
          'After breakfast, start your journey by Bullet Train (approximately 3.5 hours), watching the scenery change from busy city to quieter towns and open landscapes',
          'Once you reach Kanazawa, the vibe feels different — calmer and more traditional',
          'Visit the Higashi Chaya District, known for its old wooden houses and traditional tea houses',
          'The narrow, charming streets really feel like stepping into old Japan',
          'Overnight stay at Kanazawa Tokyu Hotel',
          'Meals: Breakfast included at hotel'
        ]
      },
      {
        day: 5,
        title: 'Finding Your Calm: Torii Gates, Temples & Quiet Kyoto Moments',
        activities: [
          'After breakfast, board the train toward Kyoto with soft glimpses of Lake Biwa drifting past like a moving painting',
          'By the time you arrive, Kyoto feels different — slower, softer, older. This is where Japan\'s soul quietly lives',
          'Your afternoon begins at Fushimi Inari Taisha, walking through endless red torii gates that wind gently up the hillside',
          'Next, visit Sanjusangen-do, a Buddhist temple famed for its 1,001 statues',
          'Overnight stay at Hotel Nikko Princess Kyoto',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 6,
        title: 'Osaka City Experience: Neon Streets & Everyday Life',
        activities: [
          'After breakfast, travel from Kyoto into Osaka — a city that is louder, brighter, warmer and full of life',
          'Begin in Namba and Dotonbori, where neon lights glow even in daylight and the streets buzz with life',
          'Step into Hozenji Temple, a small 17th-century temple tucked quietly between busy lanes',
          'Explore Kuromon Market and Osaka Castle',
          'Overnight stay at Hotel Nikko Princess Kyoto',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 7,
        title: 'Departure: Taking Japan Home in Your Heart',
        activities: [
          'After breakfast, it\'s time to say goodbye',
          'Complete your check-out and transfer to the airport, carrying more than just souvenirs',
          'You carry memories of glowing streets, quiet temples, mountain breezes, and moments that touched your heart',
          'Meals: Breakfast included'
        ]
      }
    ],
    inclusions: [
      '6 nights accommodation in handpicked hotels (Tokyo 3N, Kanazawa 1N, Kyoto 2N)',
      'Daily breakfast plus dinners as per itinerary',
      'Full-day Mount Fuji tour with Lake Kawaguchi, Chureito Pagoda, Oshino Hakkai & 5th Station',
      'Bullet Train ride from Tokyo to Kanazawa and Kanazawa to Kyoto',
      'Tokyo city tour - Imperial Palace, Senso-ji Temple, Nakamise Street, Shibuya & Harajuku',
      'Kanazawa Higashi Chaya District visit',
      'Kyoto tour - Fushimi Inari Taisha & Sanjusangen-do',
      'Osaka city experience - Namba, Dotonbori, Hozenji Temple, Kuromon Market & Osaka Castle',
      'All transfers and sightseeing as per itinerary'
    ],
    exclusions: [
      'International flight tickets',
      'Japan visa charges',
      'Travel insurance',
      'Lunches unless specified',
      'Personal expenses, shopping & tips',
      'Any services not mentioned in inclusions'
    ],
    hotels: [
      { city: 'Tokyo', name: 'Asakusa View Hotel', category: 'Luxury', nights: 3, meals: 'Breakfast & Dinner' },
      { city: 'Kanazawa', name: 'Kanazawa Tokyu Hotel', category: 'Luxury', nights: 1, meals: 'Breakfast' },
      { city: 'Kyoto', name: 'Hotel Nikko Princess Kyoto', category: 'Luxury', nights: 2, meals: 'Breakfast & Dinner' }
    ],
    transportation: 'Bullet Train (Shinkansen), private coach and local transfers as per itinerary',
    terms: [
      'Tour cost is ₹3,60,000 per person with Luxury Experiences',
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport with minimum 6 months validity required',
      'Japan visa to be arranged separately (assistance available)',
      'Package can be altered/changed as per requirement (subject to availability)',
      'Itinerary may be rescheduled subject to weather conditions',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  'singapore-malaysia-6n-7d': {
    id: 'singapore-malaysia-6n-7d',
    title: 'Unbelievable Singapore and Malaysia',
    subtitle: '6 Nights / 7 Days',
    image: '/assets/img/singapore.jpg',
    price: '₹1,60,000',
    duration: '7 days',
    location: 'Singapore & Malaysia',
    persons: 'Per Person',
    description: 'Singapore 3N, Kuala Lumpur 3N - Universal Studios, Sentosa, Genting Highlands & KL Tower',
    overview: 'Embark on a captivating 6-night journey through Singapore and Malaysia, where modern marvels meet rich cultural heritage. Start your adventure in Singapore with iconic attractions like the Gardens by the Bay, Universal Studios, and a scenic River Cruise along the Singapore River. Experience the vibrant Sentosa Island with thrilling cable car rides and world-class entertainment. Cross into Malaysia to explore the grandeur of Kuala Lumpur, from the towering KL Tower to the serene Batu Caves, and unwind in the cool highlands of Genting. Enjoy seamless transfers, guided city tours, delicious Indian meals, and comfortable stays, ensuring an unforgettable travel experience filled with excitement, exploration, and relaxation.',
    highlights: [
      '06 nights\' accommodation in Singapore and Malaysia',
      'Private Transfer from the Singapore Airport to the Hotel',
      'All sightseeing and transfers are on shared transport',
      'Daily Continental Breakfast, Indian Veg/Non-Veg Lunch and Dinner',
      'City Tour in Singapore (Little India, Merlion Statue, Chinatown, Sri Mariamman Temple, Esplanade)',
      'Gardens by the Bay (Cloud Forest, Flower Dome, Light & Sound Show)',
      'River Cruise (Bum Boat Ride along Singapore River)',
      'Marina Bay Sands Sky Park Observation Deck',
      'Sentosa Island Tour (Cable Car, Madame Tussauds 5-in-1, Wings of Time)',
      'Full Day at Universal Studios Singapore (7 themed areas, thrilling rides)',
      'Putrajaya orientation tour with photo-stop',
      'Kuala Lumpur City Tour (National Mosque, King\'s Palace, Sultan Abdul Samad Building, Merdeka Square, Menara KL Tower)',
      'Batu Caves and Genting Highlands Tour (Cable Car, Batu Caves photo stop, Skyway Ride)',
      'Services of an English-speaking Tour Manager for Group above 16 Pax only',
      'Travel Insurance for passengers up to 69 years',
      'Flights not included in Joining Direct*'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival In Singapore – City Tour, Marina Bay, Gardens By The Bay',
        activities: [
          'Upon arrival at Singapore International Airport, complete the necessary immigration and customs procedures',
          'Board the coach for your Singapore city tour (En-route breakfast at Indian restaurant, depending on flight arrival)',
          'The tour takes you through Little India, the iconic Merlion statue, scenic views of the Singapore River, the vibrant streets of Chinatown, the historic Sri Mariamman Temple, and the architectural marvel of the Esplanade',
          'Continue to the Marina Bay Sands Sky Park Observation Deck',
          'Visit Gardens by the Bay - Cloud Forest, Flower Dome and the Light & Sound Show',
          'Overnight stay at ibis Styles Singapore Albert',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Afternoon Sentosa Island Tour (Cable Car, Madame Tussauds and Wings of Time)',
        activities: [
          'Enjoy a buffet breakfast at the hotel, with the morning free for personal activities',
          'After a buffet lunch, embark on a Sentosa Island tour - a paradise for adventure and leisure',
          'Reach the island via a scenic cable car ride',
          'Experience Madame Tussauds 5-in-1 and the Wings of Time show',
          'Take a relaxing break to enjoy High Tea & Snacks in Sentosa (Tea/Coffee & Samosa)',
          'Overnight stay at ibis Styles Singapore Albert',
          'Meals: Breakfast, Lunch, Dinner & High Tea included'
        ]
      },
      {
        day: 3,
        title: 'Full Day Universal Studios & Singapore River Cruise',
        activities: [
          'Start your day with a buffet breakfast at the hotel, then head to Universal Studios Singapore with an SGD20 lunch coupon',
          'Dive into action-packed adventures, from battling villains in Sci-Fi City to meeting beloved characters in Far Far Away',
          'Explore the seven themed areas inspired by popular films, with thrilling rides like the Mummy\'s Curse in Ancient Egypt, the Madagascar Boat Ride, and Shrek\'s Adventure',
          'With 24 thrilling rides, Universal Studios Singapore offers a cinematic adventure for everyone',
          'Later enjoy the Singapore River Cruise (Bum Boat Ride)',
          'Overnight stay at ibis Styles Singapore Albert',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 4,
        title: 'Transfer From Singapore To Kuala Lumpur – En-route Putrajaya Tour',
        activities: [
          'After breakfast / packed breakfast, gather in the lobby and transfer at 9:00 am to the Coach Station for Kuala Lumpur',
          'En route, visit Putrajaya, an expansive complex spanning 11,000 acres within the Multimedia Super Corridor',
          'Known as the Garden City, Putrajaya features abundant green spaces and 13 distinct gardens, centered around a large man-made lake',
          'Photo stops at the National Mosque, Putra Bridge and official government buildings',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Breakfast included at hotel'
        ]
      },
      {
        day: 5,
        title: 'Full Day Genting Highlands Tour With Batu Caves',
        activities: [
          'Start your day with an early breakfast at your hotel in Kuala Lumpur',
          'Embark on a journey to Genting Highlands, stopping en route at Batu Caves, a series of limestone caves and cave temples just outside Kuala Lumpur',
          'Continue to Genting Highlands and enjoy the cool mountain air and breathtaking views of the surrounding landscapes',
          'Take a ride on the Genting Skyway cable car, which offers panoramic views',
          'Spend the day exploring the attractions and entertainment options at Genting Highlands',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 6,
        title: 'Kuala Lumpur City Tour With KL Tower',
        activities: [
          'Start your day with a delicious American breakfast at your hotel',
          'Embark on an exciting city tour of Kuala Lumpur, visiting the most iconic landmarks and attractions',
          'Visit the observatory deck at the Menara Kuala Lumpur Tower for panoramic views of the Kuala Lumpur skyline',
          'Explore the beautiful National Mosque, a symbol of Islamic architecture',
          'Visit the King\'s Palace, Sultan Abdul Samad Building and Merdeka Square',
          'Overnight stay at Regalia Upper View Hotel',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 7,
        title: 'Departure from Kuala Lumpur',
        activities: [
          'Start your day with a buffet breakfast at the hotel',
          'After checking out, all luggage will be transferred onto the coach',
          'Enjoy a buffet lunch, depending on your flight schedule',
          'Transfer to Kuala Lumpur International Airport for your flight back home',
          'Meals: Breakfast & Lunch included (depending on flight departure)'
        ]
      }
    ],
    inclusions: [
      '06 nights\' accommodation in Singapore (3N) and Malaysia (3N)',
      'Private Transfer from the Singapore Airport to the Hotel',
      'All sightseeing and transfers on shared transport',
      'Daily Continental Breakfast, Indian Veg/Non-Veg Lunch and Dinner',
      'All entry fees for sightseeing mentioned in the itinerary',
      'Singapore City Tour (Little India, Merlion Statue, Chinatown, Sri Mariamman Temple, Esplanade)',
      'Gardens by the Bay (Cloud Forest, Flower Dome, Light & Sound Show)',
      'River Cruise (Bum Boat Ride along Singapore River)',
      'Marina Bay Sands Sky Park Observation Deck',
      'Sentosa Island Tour (Cable Car, Madame Tussauds 5-in-1, Wings of Time)',
      'Full Day at Universal Studios Singapore with SGD20 lunch coupon',
      'Putrajaya orientation tour with photo-stop',
      'Kuala Lumpur City Tour with Menara KL Tower',
      'Batu Caves and Genting Highlands Tour with Skyway cable car ride',
      'Services of an English-speaking Tour Manager (for groups above 16 Pax only)',
      'Travel Insurance for passengers up to 69 years'
    ],
    exclusions: [
      'International flight tickets (not included in Joining Direct)',
      'Singapore and Malaysia visa charges',
      'Personal expenses, shopping & tips',
      'Any meals or services not mentioned in inclusions',
      'Optional activities and attractions',
      'Expenses due to factors beyond our control'
    ],
    hotels: [
      { city: 'Singapore', name: 'ibis Styles Singapore Albert', category: 'Deluxe', nights: 3, meals: 'Breakfast, Lunch & Dinner' },
      { city: 'Kuala Lumpur', name: 'Regalia Upper View Hotel', category: 'Deluxe', nights: 3, meals: 'Breakfast, Lunch & Dinner' }
    ],
    transportation: 'Private airport transfer in Singapore; shared coach for all sightseeing and the Singapore–Kuala Lumpur transfer',
    terms: [
      'Tour cost is ₹1,60,000 per person with Luxury Experiences',
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport with minimum 6 months validity required',
      'Singapore and Malaysia visas to be arranged separately (assistance available)',
      'Tour Manager services apply only for groups above 16 Pax',
      'Travel insurance covers passengers up to 69 years of age',
      'Meal timings on arrival and departure days depend on flight schedules',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  'essence-of-europe-7n-8d': {
    id: 'essence-of-europe-7n-8d',
    title: 'Essence of Europe',
    subtitle: '7 Nights / 8 Days',
    image: '/assets/img/europe.jpg',
    price: '₹2,65,000',
    duration: '8 days',
    location: 'Italy & Switzerland',
    persons: 'Per Person',
    description: 'Rome 2N, Ferrara 1N, Milan 1N, Zurich 3N - Vatican, Venice, Lake Como & Mt. Titlis',
    overview: 'Journey through the very best of Italy and Switzerland on this handpicked 8-day escape. Begin in Rome with the Vatican and St. Peter\'s Basilica, capture iconic moments at the Colosseum and Trevi Fountain, and marvel at the Leaning Tower of Pisa. Explore Renaissance Florence, take a romantic gondola ride through Venice\'s canals, and experience the elegance of Milan and the serenity of Lake Como. Cross into Switzerland to ascend Mt. Titlis aboard the world\'s first revolving cable car, walk Europe\'s highest suspension bridge, and discover charming Lucerne — with an optional excursion to Jungfraujoch, the Top of Europe.',
    highlights: [
      'Stay in handpicked 4-star hotels across Italy and Switzerland for a comfortable and memorable experience',
      'Begin your journey in Rome, exploring its timeless wonders on a city tour, including Vatican City and St. Peter\'s Basilica',
      'Capture iconic moments at the Colosseum, Trevi Fountain, and Victor Emmanuel II Monument',
      'Visit the world-famous Leaning Tower of Pisa at the Piazza dei Miracoli, a UNESCO World Heritage Site',
      'Explore Florence, the cradle of the Renaissance, and admire panoramic views from Piazzale Michelangelo',
      'Discover the enchanting city of Venice, the "Floating City," with a romantic gondola ride through its scenic canals',
      'Experience the elegance of Milan, Italy\'s fashion capital, with visits to the Duomo di Milano and Galleria Vittorio Emanuele II',
      'Enjoy the breathtaking serenity of Lake Como, known for its crystal-clear waters and charming alpine villages',
      'Cross into Switzerland and explore Zurich, a perfect blend of sophistication and alpine charm',
      'Ascend Mt. Titlis (3,020m) aboard the world\'s first revolving cable car, and brave the thrilling Cliff Walk',
      'Visit Lucerne, famous for the Chapel Bridge and Lion Monument, and enjoy shopping for Swiss souvenirs',
      'Optional excursion to Jungfraujoch – The Top of Europe, featuring the Ice Palace and Sphinx Observatory',
      'Experience the scenic beauty of Interlaken, nestled between two sparkling lakes',
      'Daily Breakfasts and Dinners, with select Indian meals included for comfort and variety',
      'Travel in a luxury air-conditioned coach with an English/Hindi-speaking Tour Manager throughout',
      'The driver charges are included for a seamless and worry-free journey'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Rome Awaits – A Grand Beginning to Your European Journey',
        activities: [
          'Welcome to Rome, a city where ancient history, timeless architecture, and vibrant culture come together',
          'Upon arrival at the airport, our friendly representative will greet you at the arrival hall and assist you with your transfer to the hotel',
          'After check-in, take some time to relax and settle in',
          'The rest of the day is at leisure for you to unwind or explore the surroundings at your own pace',
          'In the evening, join your fellow travelers for a delicious dinner',
          'Overnight stay at Hampton By Hilton Rome North Fiano Romano',
          'Meals: Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Rome City Tour with Vatican City and St. Peter\'s Basilica',
        activities: [
          'After a hearty breakfast at the hotel, begin an immersive exploration of Rome, steeped in history, art, and imperial grandeur',
          'Accompanied by a tour manager, the first stop is Vatican City, the smallest independent state in the world',
          'Visit the majestic St. Peter\'s Basilica, a masterpiece of Renaissance architecture adorned with incredible works by Michelangelo and Bernini',
          'Marvel at the grandeur of its dome, sculptures, and the awe-inspiring Pietà',
          'Return to the heart of Rome for a panoramic tour including the Colosseum, Trevi Fountain and Victor Emmanuel II Monument',
          'Overnight stay at Hampton By Hilton Rome North Fiano Romano',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 3,
        title: 'Leaning Tower of Pisa – Florence City Tour & Piazzale Michelangelo',
        activities: [
          'Start your day with a scenic drive through the Tuscan countryside as you journey from Rome toward the iconic city of Pisa',
          'Visit the stunning Piazza dei Miracoli, or Square of Miracles — a UNESCO World Heritage Site',
          'Marvel at the world-famous Leaning Tower of Pisa, along with the Baptistery, Monumental Cemetery, and Cathedral of St. Mary of the Assumption',
          'Continue to Florence, the cradle of the Renaissance, and admire panoramic views from Piazzale Michelangelo',
          'Overnight stay at Radisson Hotel Ferrara',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 4,
        title: 'Transfer To Venice – The Floating City Of Italy With Gondola Ride',
        activities: [
          'Today\'s journey transports you to the magical world of Venice, a city built entirely on water',
          'After breakfast, check out and drive to the Venetian pier, where a private boat awaits to take you across the shimmering waters of the Giudecca Canal',
          'Arrive at the vibrant St. Mark\'s Square, the heart of Venice',
          'Admire the magnificent St. Mark\'s Basilica, a masterpiece of Byzantine architecture adorned with intricate mosaics and golden domes',
          'Enjoy a romantic gondola ride through the scenic canals',
          'Overnight stay at Zeus Essence Dolce by Wyndham Milan Malpensa',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 5,
        title: 'Milan\'s Elegance & the Serenity of Lake Como – Drive to Zurich',
        activities: [
          'Begin your morning with a delicious breakfast before checking out from your hotel in Milan',
          'Enjoy a brief yet enriching orientation tour of Milan, Italy\'s fashion and design capital',
          'Visit the majestic Milan Cathedral (Duomo di Milano), one of the largest and most intricate Gothic cathedrals in the world',
          'Step into the historic Galleria Vittorio Emanuele II, a stunning 19th-century shopping arcade with beautiful glass domes and mosaics',
          'Continue to Lake Como for its crystal-clear waters and charming alpine villages, then drive on to Zurich',
          'Overnight stay at Radisson Hotel & Suites Zurich',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 6,
        title: 'Mt. Titlis Rotair Cable Car (3,020m) - Orientation Tour of Lucerne',
        activities: [
          'After breakfast, head to the mountain village of Engelberg for a thrilling alpine experience',
          'Enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world\'s first revolving cable car',
          'At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers',
          'Test your nerves with a walk on the Cliff Walk, Europe\'s highest suspension bridge',
          'Later, enjoy an orientation tour of Lucerne including the Chapel Bridge and Lion Monument',
          'Overnight stay at Radisson Hotel & Suites Zurich',
          'Meals: Breakfast, Lunch & Dinner included'
        ]
      },
      {
        day: 7,
        title: 'Optional Excursion To Jungfraujoch – The Top Of Europe & Scenic Interlaken (Extra Cost)',
        activities: [
          'After breakfast, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost)',
          'Begin at Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes',
          'Board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet',
          'At the summit, immerse yourself in a world of eternal snow and ice - wander through the Ice Palace and visit the Sphinx Observatory',
          'Experience the scenic beauty of Interlaken, nestled between two sparkling lakes',
          'Overnight stay at Radisson Hotel & Suites Zurich',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 8,
        title: 'Adieu Europe – A Grand Journey Concludes',
        activities: [
          'After breakfast, it\'s time to bid farewell to your unforgettable European adventure',
          'Check out from the hotel and transfer to Zurich Airport for your flight back home',
          'Take with you memories of snow-capped peaks, crystal-clear lakes, charming alpine towns, and the warmth of shared experiences',
          'Meals: Breakfast included'
        ]
      }
    ],
    inclusions: [
      '7 nights stay in handpicked 4-star hotels across Italy and Switzerland',
      'Daily Breakfasts and Dinners, with select Indian meals included',
      'Rome city tour including Vatican City and St. Peter\'s Basilica',
      'Photo stops at the Colosseum, Trevi Fountain and Victor Emmanuel II Monument',
      'Visit to the Leaning Tower of Pisa at Piazza dei Miracoli',
      'Florence city tour with panoramic views from Piazzale Michelangelo',
      'Venice visit with private boat transfer and romantic gondola ride',
      'Milan orientation tour - Duomo di Milano and Galleria Vittorio Emanuele II',
      'Lake Como visit',
      'Mt. Titlis excursion with Rotair revolving cable car and Cliff Walk',
      'Lucerne orientation tour - Chapel Bridge and Lion Monument',
      'Travel in a luxury air-conditioned coach',
      'English/Hindi-speaking Tour Manager throughout',
      'Driver charges included'
    ],
    exclusions: [
      'International flight tickets',
      'Schengen visa charges',
      'Travel insurance',
      'Jungfraujoch excursion – The Top of Europe (available at extra cost)',
      'Lunches unless specified',
      'Personal expenses, shopping & tips',
      'Any services not mentioned in inclusions'
    ],
    hotels: [
      { city: 'Rome', name: 'Hampton By Hilton Rome North Fiano Romano', category: '4 Star', nights: 2, meals: 'Breakfast & Dinner' },
      { city: 'Ferrara', name: 'Radisson Hotel Ferrara', category: '4 Star', nights: 1, meals: 'Breakfast & Dinner' },
      { city: 'Milan', name: 'Zeus Essence Dolce by Wyndham Milan Malpensa', category: '4 Star', nights: 1, meals: 'Breakfast & Dinner' },
      { city: 'Zurich', name: 'Radisson Hotel & Suites Zurich', category: '4 Star', nights: 3, meals: 'Breakfast & Dinner' }
    ],
    transportation: 'Luxury air-conditioned coach with English/Hindi-speaking Tour Manager; driver charges included',
    terms: [
      'Tour cost is ₹2,65,000 per person with Luxury Experiences',
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport with minimum 6 months validity required',
      'Schengen visa to be arranged separately (assistance available)',
      'Jungfraujoch excursion is optional and available at an additional cost',
      'Cable car operations are subject to weather conditions',
      'Package can be altered/changed as per requirement (subject to availability)',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  },

  'amazing-bhutan-7n-8d': {
    id: 'amazing-bhutan-7n-8d',
    title: 'Amazing Bhutan',
    subtitle: '7 Nights / 8 Days',
    image: '/assets/img/bhutan.jpg',
    price: '₹40,000',
    duration: '8 days',
    location: 'Bhutan',
    persons: 'Per Person',
    description: 'Phuentsholing, Thimphu, Punakha & Paro - Tiger\'s Nest, Dochula Pass and Chele La Pass',
    overview: 'Discover the Land of the Thunder Dragon on this 8-day journey through Bhutan. Enter by road from India at Phuentsholing, explore the capital Thimphu with its dzongs and viewpoints, cross the scenic Dochula Pass to Punakha, and reach the beautiful Paro valley. The highlight is the excursion to the legendary Taktsang Monastery — the Tiger\'s Nest — perched dramatically on a cliffside, followed by a day trip to the pristine Chele La Pass at 3,988m with sweeping views of Mt Jomolhari.',
    highlights: [
      'Accommodation in All Places',
      'Daily Breakfast & Dinner will be provided',
      'All Tours and Transfers are on point to point basis',
      'Thimphu Local Sightseeing',
      'Punakha Excursion',
      'Excursion to Taktsang Monastery (Tiger\'s Nest)',
      'All Permit Fee and Hotel Taxes (as per the itinerary)',
      'SDF & Guide Charges'
    ],
    itinerary: [
      {
        day: 1,
        title: 'NJP Rly Station / IXB Airport – Phuentsholing (170 kms / 5 hrs / Altitude: 293 mts)',
        activities: [
          'Meet & Greet on arrival at NJP Railway Station / IXB Airport',
          'Transfer to Phuentsholing - The Gateway of Bhutan by Road from India',
          'It is a thriving commercial center on the northern edge of the Indian Plains',
          'On arrival check in at the hotel',
          'Overnight stay at Hotel Bhutan Ga Me Ga',
          'Meals: Dinner included'
        ]
      },
      {
        day: 2,
        title: 'Phuentsholing to Thimphu (176 kms / 6 hrs / Altitude: 2350 mts)',
        activities: [
          'The driver and guide will meet at around 8:30 AM at the Phuentsholing border for immigration (process takes a maximum of 1 hour)',
          'After breakfast, proceed towards Thimphu',
          'Halt at Chojum to take photographs of the confluence of two rivers of Bhutan, Thimphu Chu and Paro Chu',
          'Reach Thimphu in the evening and check in at the hotel',
          'Evening free for your own activity',
          'Overnight stay at Hotel Dralha',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 3,
        title: 'Thimphu Local Sightseeing',
        activities: [
          'After breakfast, the day is dedicated to sightseeing in Thimphu',
          'Visit Kuenselphodrang (Buddha Dordenma) and the National Memorial Chorten',
          'Visit the Folk Heritage Museum and Sangaygang view point',
          'Visit the Takin Reserve Centre and Tashichho Dzong (Fortress of the Glorious Religion)',
          'Visit Simply Bhutan',
          'Overnight stay at Hotel Dralha',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 4,
        title: 'Thimphu to Punakha via Dochula Pass and Sightseeing (4 Hrs)',
        activities: [
          'After breakfast, drive to Punakha/Wangdue via the scenic Dochula Pass',
          'Upon arrival, check into your hotel and enjoy lunch',
          'Visit the Punakha Dzong, Chimi Lhakhang, Punakha Suspension Bridge, and Punakha Village',
          'Return to the hotel for an overnight stay',
          'Overnight stay at Hotel ZHUSA',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 5,
        title: 'Punakha to Paro and Paro Sightseeing',
        activities: [
          'After breakfast, drive to Paro via Dochu La Pass, passing the Paro Chhu and Wang Chhu river valleys',
          'Visit Simtokha Dzong en route',
          'In Paro, check into your hotel',
          'Visit Ta Dzong, Rinpung Dzong and Tamchog Lhakhang',
          'Overnight stay at Udumwara Resort',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 6,
        title: 'Day Excursion to Taktsang Monastery (Tiger\'s Nest)',
        activities: [
          'After early morning breakfast, start the excursion tour to Taktsang Monastery',
          'Taktsang Palphug Monastery, also known as Tiger\'s Nest, is an amazing Buddhist monastery, temple and sacred site located in the upper Paro town',
          'Built in 1692, Guru Padmasambhava is believed to have meditated at this site for 3 years',
          'Guru Padmasambhava is known to be the founder of the Buddhist religion in Bhutan',
          'Also visit Kyichu Lhakhang, one of the oldest Buddhist temples in Bhutan',
          'Overnight stay at Udumwara Resort',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 7,
        title: 'The Chele La Pass (Day Excursion) & Transfer To Phuentsholing',
        activities: [
          'Chele La remains one of the least visited areas in the country and retains the air of an unspoiled, primeval forest',
          'Drive to Chele La Pass (3,988m), from which on a clear day the view sweeps away to Bhutan\'s second-highest sacred peak, Mt Jomolhari (7,314m)',
          'Later transfer to Phuentsholing and check in at the hotel',
          'Evening free for leisure',
          'Overnight stay at Hotel Bhutan Ga Me Ga',
          'Meals: Breakfast & Dinner included'
        ]
      },
      {
        day: 8,
        title: 'Phuentsholing To Bagdogra / NJP Drop',
        activities: [
          'On the final day of your journey in Bhutan, begin with a leisurely breakfast at your hotel in Phuentsholing',
          'After enjoying your meal, check out and bid farewell to the warm hospitality that has accompanied you throughout your stay',
          'Your driver will transfer you to Bagdogra Airport / NJP Station for your departure',
          'Take a moment to reflect on the memories you\'ve made during your time in the Land of the Thunder Dragon',
          'Meals: Breakfast included at hotel'
        ]
      }
    ],
    inclusions: [
      'Accommodation in all places as per itinerary',
      'Daily Breakfast & Dinner',
      'All tours and transfers on point to point basis',
      'Thimphu local sightseeing',
      'Punakha excursion via Dochula Pass',
      'Excursion to Taktsang Monastery (Tiger\'s Nest)',
      'Chele La Pass day excursion',
      'All permit fees and hotel taxes (as per the itinerary)',
      'SDF (Sustainable Development Fee) & Guide Charges'
    ],
    exclusions: [
      'Airfare / train fare to and from Bagdogra / NJP',
      'Lunch and any meals not mentioned in inclusions',
      'Travel insurance',
      'Personal expenses, shopping & tips',
      'Monument entrance fees not specified in the itinerary',
      'Expenses due to factors beyond our control (natural calamities, roadblocks, strikes etc.)'
    ],
    hotels: [
      { city: 'Phuentsholing', name: 'Hotel Bhutan Ga Me Ga', category: 'Deluxe', nights: 2, meals: 'Breakfast & Dinner' },
      { city: 'Thimphu', name: 'Hotel Dralha', category: 'Deluxe', nights: 2, meals: 'Breakfast & Dinner' },
      { city: 'Punakha', name: 'Hotel ZHUSA', category: 'Deluxe', nights: 1, meals: 'Breakfast & Dinner' },
      { city: 'Paro', name: 'Udumwara Resort', category: 'Deluxe', nights: 2, meals: 'Breakfast & Dinner' }
    ],
    transportation: 'Private vehicle on point to point basis with driver and guide',
    terms: [
      'Tour cost is ₹40,000 per person with Luxury Stay',
      'For package confirmation, you need to deposit 50% payment in our company account',
      'Guest will have to make 100% payment before 30 days of arrival',
      'Valid passport or Voter ID card required for Bhutan entry permit',
      'Immigration process at Phuentsholing border takes approximately 1 hour',
      'SDF (Sustainable Development Fee) is included as per current government rates',
      'Package can be altered/changed as per requirement (subject to availability)',
      'Itinerary may be rescheduled subject to weather and road conditions',
      'All cancellations to be communicated in writing; advance amount is non-refundable',
      'Specially Jain Food Available on request'
    ],
    validFrom: 'Year Round',
    validTill: 'Year Round'
  }
}

export default function PackageDetails() {
  const { packageId } = useParams()
  const navigate = useNavigate()
  const packageInfo = packageData[packageId]

  const handleBookNow = () => {
    navigate('/')
    setTimeout(() => {
      const element = document.getElementById('book-appointment')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 100)
  }

  if (!packageInfo) {
    return (
      <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
          <div className="container py-5">
            <div className="row justify-content-center py-5">
              <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                <h1 className="display-3 text-white animated slideInDown">
                  Package Not Found
                </h1>
                <Link to="/" className="btn btn-outline-light py-3 px-5 mt-3">
                  Go Back Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Hero Header */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                {packageInfo.title}
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                {packageInfo.subtitle}
              </p>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/" className="text-white">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/packages" className="text-white">Packages</Link>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    {packageInfo.title}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          {/* Package Header */}
          <div className="row g-5 mb-5">
            <div className="col-lg-6">
              <div className="overflow-hidden rounded">
                <img 
                  className="img-fluid w-100" 
                  src={packageInfo.image} 
                  alt={packageInfo.title}
                  style={{ objectFit: 'cover', height: '400px' }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="d-flex border-bottom mb-3">
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-map-marker-alt text-primary me-2" />
                  {packageInfo.location}
                </small>
                <small className="flex-fill text-center border-end py-2">
                  <i className="fa fa-calendar-alt text-primary me-2" />
                  {packageInfo.duration}
                </small>
                <small className="flex-fill text-center py-2">
                  <i className="fa fa-user text-primary me-2" />
                  {packageInfo.persons}
                </small>
              </div>
              <h2 className="mb-3">{packageInfo.title}</h2>
              <h3 className="text-primary mb-4">Redeem Offer</h3>
              <div className="mb-3">
                <small className="fa fa-star text-primary" />
                <small className="fa fa-star text-primary" />
                <small className="fa fa-star text-primary" />
                <small className="fa fa-star text-primary" />
                <small className="fa fa-star text-primary" />
              </div>
              <p className="mb-4">{packageInfo.description}</p>
              <div className="d-flex gap-3">
                <button
                  onClick={handleBookNow}
                  className="btn btn-primary px-4 py-2"
                  style={{ borderRadius: "30px" }}
                >
                  Book Now
                </button>
              </div>
            </div>
          </div>

          {/* Overview */}
          <div className="row mb-5">
            <div className="col-12">
              <h3 className="mb-4">
                <i className="fa fa-info-circle text-primary me-2" />
                Package Overview
              </h3>
              <p className="lead">{packageInfo.overview}</p>
            </div>
          </div>

          {/* Trip Highlights */}
          {packageInfo.highlights && packageInfo.highlights.length > 0 && (
            <div className="row mb-5">
              <div className="col-12">
                <h3 className="mb-4">
                  <i className="fa fa-star text-primary me-2" />
                  Trip Highlights
                </h3>
                <div className="card border-primary">
                  <div className="card-body">
                    <div className="row g-2">
                      {packageInfo.highlights.map((item, index) => (
                        <div key={index} className="col-md-6">
                          <p className="mb-2">
                            <i className="fa fa-check-circle text-primary me-2" />
                            {item}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Itinerary */}
          <div className="row mb-5">
            <div className="col-12">
              <h3 className="mb-4">
                <i className="fa fa-route text-primary me-2" />
                Detailed Itinerary
              </h3>
              <div className="row g-4">
                {packageInfo.itinerary.map((day, index) => (
                  <div key={index} className="col-12">
                    <div className="card border-primary h-100">
                      <div className="card-header bg-primary text-white">
                        <h4 className="mb-0 text-white">
                          Day {day.day}: {day.title}
                        </h4>
                      </div>
                      <div className="card-body">
                        <ul className="list-unstyled mb-0">
                          {day.activities.map((activity, actIndex) => (
                            <li key={actIndex} className="mb-2">
                              <i className="fa fa-check-circle text-primary me-2" />
                              {activity}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Inclusions & Exclusions */}
          <div className="row mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card border-success h-100">
                <div className="card-header bg-success text-white">
                  <h4 className="mb-0">
                    <i className="fa fa-check-circle me-2" />
                    Package Inclusions
                  </h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled mb-0">
                    {packageInfo.inclusions.map((item, index) => (
                      <li key={index} className="mb-2">
                        <i className="fa fa-check text-success me-2" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-danger h-100">
                <div className="card-header bg-danger text-white">
                  <h4 className="mb-0">
                    <i className="fa fa-times-circle me-2" />
                    Package Exclusions
                  </h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled mb-0">
                    {packageInfo.exclusions.map((item, index) => (
                      <li key={index} className="mb-2">
                        <i className="fa fa-times text-danger me-2" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Hotels & Transportation */}
          <div className="row mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card border-info h-100">
                <div className="card-header bg-info text-white">
                  <h4 className="mb-0">
                    <i className="fa fa-hotel me-2" />
                    Hotel Details
                  </h4>
                </div>
                <div className="card-body">
                  {packageInfo.hotels.map((hotel, index) => (
                    <div key={index} className="mb-3 pb-3 border-bottom">
                      <h5 className="text-primary">{hotel.city}</h5>
                      <p className="mb-1"><strong>Hotel:</strong> {hotel.name}</p>
                      <p className="mb-1"><strong>Category:</strong> {hotel.category}</p>
                      <p className="mb-0"><strong>Nights:</strong> {hotel.nights}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card border-warning h-100">
                <div className="card-header bg-warning text-white">
                  <h4 className="mb-0">
                    <i className="fa fa-car me-2" />
                    Transportation
                  </h4>
                </div>
                <div className="card-body">
                  <p className="mb-0">{packageInfo.transportation}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="row">
            <div className="col-12">
              <div className="card border-secondary">
                <div className="card-header bg-secondary text-white">
                  <h4 className="mb-0">
                    <i className="fa fa-file-alt me-2" />
                    Terms & Conditions
                  </h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled mb-0">
                    {packageInfo.terms.map((term, index) => (
                      <li key={index} className="mb-2">
                        <i className="fa fa-arrow-right text-primary me-2" />
                        {term}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="row mt-5">
            <div className="col-12 text-center">
              <button
                onClick={handleBookNow}
                className="btn btn-primary btn-lg px-5 py-3"
                style={{ borderRadius: "30px" }}
              >
                Book This Package Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
